import { gql } from "lib/apolloClient";

export const createConversation = gql`
  mutation createToddleDocConversation(
    $input: CreateToddleDocConversationsInput!
  ) {
    platform {
      createToddleDocConversation(input: $input) {
        isSuccess
        warning
        conversations {
          id
          referenceId
          colorCode
          messages {
            id
            content
            state
            type
            authorType
          }
        }
      }
      __typename
    }
  }
`;

export const updateConversation = gql`
  mutation updateToddleDocConversation(
    $input: [ToddleDocConversationUpdateInput!]
  ) {
    platform {
      updateToddleDocConversation(input: $input) {
        isSuccess
        warning
        conversations {
          id
          colorCode
          referenceId
          messages {
            id
            content
            state
          }
        }
      }
      __typename
    }
  }
`;

export const deleteConversation = gql`
  mutation deleteToddleDocConversation(
    $input: DeleteToddleDocConversationInput!
  ) {
    platform {
      deleteToddleDocConversation(input: $input) {
        isSuccess
        warning
      }
      __typename
    }
  }
`;
